import { useState } from 'react';

export default function HomeCTA() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('contact_alt') as string;

    if (honeypot && honeypot.trim() !== '') {
      setStatus('success');
      setEmail('');
      return;
    }

    formData.delete('contact_alt');

    try {
      const response = await fetch('https://readdy.ai/api/form/d9rhfe7nahb7382ovmmg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText;
        setStatus('error');
        setErrorMessage(serverMsg || '订阅失败，请稍后重试');
      }
    } catch {
      setStatus('error');
      setErrorMessage('网络错误，请检查网络后重试');
    }
  };

  return (
    <section className="relative py-20 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20golden%20and%20amber%20abstract%20energy%20waves%20on%20dark%20background%2C%20esports%20arena%20atmosphere%2C%20soft%20glowing%20particles%2C%20cinematic%20gradient%2C%20dramatic%20warm%20lighting%2C%20professional%20gaming%20vibe&width=1600&height=600&seq=cta-bg-lol&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>

      <div className="relative z-10 max-w-2xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl text-background-50 mb-3">
          订阅撸啊撸攻略更新
        </h2>
        <p className="text-background-200/80 text-sm md:text-base mb-8">
          第一时间获取最新版本强势英雄推荐和上分攻略，不错过任何提升机会
        </p>

        {status === 'success' ? (
          <div className="flex items-center justify-center gap-2 text-accent-400 bg-accent-500/10 border border-accent-500/20 rounded-xl px-6 py-4">
            <i className="ri-checkbox-circle-line text-xl"></i>
            <span className="text-sm font-medium">订阅成功！感谢你的关注</span>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            data-readdy-form
            className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          >
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入你的邮箱地址"
              required
              className="flex-1 px-4 py-3 rounded-lg bg-background-50/10 border border-background-50/20 text-background-50 placeholder:text-background-400 text-sm focus:outline-none focus:border-primary-400 transition-colors"
            />
            <input
              type="text"
              name="contact_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="honeypot-field"
            />
            <button
              type="submit"
              className="px-6 py-3 bg-primary-500 text-background-50 rounded-lg font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              立即订阅
            </button>
          </form>
        )}

        {status === 'error' && (
          <p className="mt-3 text-sm text-accent-400">{errorMessage}</p>
        )}
      </div>
    </section>
  );
}